import { BehaviorSubject } from 'rxjs';
import createStore from './createStore';


interface PageHistoryStore {
  pageStack: string[];
}
// eslint-disable-next-line import/no-mutable-exports
export let pageHistoryStore: BehaviorSubject<PageHistoryStore>;
export const getpageHistoryStoreValue = () => {
  if (!pageHistoryStore) {
    pageHistoryStore = createStore<PageHistoryStore>({
      pageStack:[]
    });
  }
  return pageHistoryStore.value;
};